module.exports = __webpack_public_path__ + "img/icon_t11.8e817739.png";